import api from './api';

// Get user role and designation from localStorage
const getUserRole = () => {
  return {
    role: localStorage.getItem('userRole'),
    designation: localStorage.getItem('userDesignation')
  };
};

// Role-based API endpoints
export const getApplicationsForUser = async () => {
  const { designation } = getUserRole();
  
  switch (designation) {
    case 'rm':
    case 'RM':
      return api.get('/rm/applications');
    case 'arm':
    case 'ARM':
      return api.get('/arm/applications');
    case 'tl':
    case 'TL':
      return api.get('/tl/pool');
    case 'manager':
    case 'Manager':
      return api.get('/manager/all-applications');
    default:
      throw new Error('Invalid user designation');
  }
};

// Get applications based on user role for dashboard
// @deprecated - Use Redux fetchApplications instead
export const getDashboardData = async () => {
  try {
    const response = await getApplicationsForUser();
    return response;
  } catch (error) {
    console.error('Error fetching dashboard data:', error);
    throw error;
  }
};

// Get restaurant approvals based on user role
// @deprecated - Use Redux fetchApplications instead
export const getRestaurantApprovals = async () => {
  try {
    const response = await getApplicationsForUser();
    return response;
  } catch (error) {
    console.error('Error fetching restaurant approvals:', error);
    throw error;
  }
};

// Get TL's assigned applications (My Tickets)
export const getTLMyApplications = async () => {
  try {
    const response = await api.get('/tl/my-applications');
    return response;
  } catch (error) {
    console.error('Error fetching TL my applications:', error);
    throw error;
  }
};

// Self assign application to TL
export const selfAssignApplication = async (applicationId) => {
  try {
    const response = await api.post('/tl/self-assign', { applicationId });
    return response;
  } catch (error) {
    console.error('Error self-assigning application:', error);
    throw error;
  }
};

// TL action on application (approve/reject)
export const tlAction = async (applicationId, action, rejectionReason = null) => {
  try {
    const payload = {
      applicationId,
      action
    };
    
    if (rejectionReason) {
      payload.rejectionReason = rejectionReason;
    }
    
    const response = await api.post('/tl/action', payload);
    return response;
  } catch (error) {
    console.error('Error performing TL action:', error);
    throw error;
  }
};

// Manager assign TL to application
export const managerAssignTL = async (applicationId, tlId) => {
  try {
    const response = await api.post('/manager/assign-tl', {
      applicationId,
      tlId
    });
    return response;
  } catch (error) {
    console.error('Error assigning TL:', error);
    throw error;
  }
};

// ARM action for forwarding to TL
export const armForwardToTL = async (applicationId, rejectionReason = null) => {
  try {
    const payload = { applicationId };
    if (rejectionReason) {
      payload.rejectionReason = rejectionReason;
    }
    const response = await api.post('/arm/forward-tl', payload);
    return response;
  } catch (error) {
    console.error('Error forwarding to TL:', error);
    throw error;
  }
};

export default {
  getApplicationsForUser,
  getDashboardData,
  getRestaurantApprovals,
  getTLMyApplications,
  selfAssignApplication,
  tlAction,
  managerAssignTL,
  armForwardToTL,
  getUserRole
};